export class FindProjectRoleAction {
  public static readonly type = '[Authorisation] FindProjectRoleAction';
  constructor(
    public readonly userId: string,
    public readonly projectId: string,
    public readonly template: boolean,
  ) {}
}
